import {observable, action} from 'mobx';

class MonitorStore{
    // 监控数据
    @observable.shallow monitors = [];

    @action setMonitors(monitors) {
        this.monitors = monitors;
    }
}

export default new MonitorStore();